import React from 'react';

const SVGChevron = props => {
  return (
    <div
      className={`svg svg--stroke svg--square-stroke svg--inline-block ${props.className ||
        ''}`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6">
        <title>Chevron</title>
        <polyline className="stroke" points="0 0 5.03 5.02 10 0" />
      </svg>
    </div>
  );
};

export default SVGChevron;



// WEBPACK FOOTER //
// ./src/svg/Chevron.js